import React, { useMemo, useState } from 'react'

import { ModalControlsStyled, Tabs, Modal, Button } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { CqParamsModalStyled } from 'Features/CheqParamsModal/CheqParamsModal.styled'
import { Tab as TabType } from 'Types/Tab'

import { MetaParamsTab } from 'Features/CheqParamsModal/Tabs/Meta/MetaParamsTab'
import { MicrosoftParamsTab } from 'Features/CheqParamsModal/Tabs/Microsoft/MicrosoftParamsTab'
import { GoogleIcon } from 'Assets/icons/GoogleIcon'
import { MetaIcon } from 'Assets/icons/MetaIcon'
import { MicrosoftIcon } from 'Assets/icons/MicrosoftIcon'
import { NewGoogleParamsTab } from './Tabs/Google/NewGoogleParamsTab'

interface CqParamsModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
}

const CqParamsModal = ({ isOpen, onOpenChange }: CqParamsModalProps) => {
  const { t } = useTranslation('domainManagement')

  const onClose = () => {
    onOpenChange(false)
  }

  const tabs = useMemo(() => {
    return [
      {
        id: 1,
        title: t('tracking_params_modal.google'),
        icon: <GoogleIcon />,
        page: <NewGoogleParamsTab closeModal={onClose} />,
      },
      {
        id: 2,
        title: t('tracking_params_modal.meta'),
        icon: <MetaIcon />,
        page: <MetaParamsTab />,
      },
      {
        id: 3,
        title: t('tracking_params_modal.microsoft'),
        icon: <MicrosoftIcon />,
        page: <MicrosoftParamsTab />,
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [activeTab, setActiveTab] = useState<TabType>(tabs[0])

  return (
    <Modal
      title={t('tracking_params_modal.title')}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
    >
      <CqParamsModalStyled>
        <Tabs tabs={tabs} activeTab={activeTab} onClick={setActiveTab} />
        <ModalControlsStyled>
          <Button
            text={t('tracking_params_modal.done')}
            onClick={() => {
              onOpenChange(false)
            }}
          />
        </ModalControlsStyled>
      </CqParamsModalStyled>
    </Modal>
  )
}

export default CqParamsModal
